<app-header [user]="user()" />

<div class="www-res-pass">
  <section class="www-res-pass__con">
    <form
      [formGroup]="formGroup"
      [ngxsFormClearOnDestroy]="_isBrowser"
      [ngxsFormDebounce]="20"
      [ngxsForm]="'resetPassword.form'"
      class="www-form www-res-pass__con__form"
      appInvalidControlScroll
      [appAnimate]="'fadeInLeft'"
      [speed]="'fast'"
      novalidate
    >
      <h3 class="www-res-pass__con__form__ti">Resetuj hasło</h3>

      <div class="row">
        <div class="col-12">
          <div class="group">
            <input [appInputValidator]="f.code" [formControlName]="'code'" id="code" type="text" autocomplete="off" />
            <label for="code" class="d-flex gap-2 align-items-center">
              <svg height="12.965" viewBox="0 0 16.421 12.965" width="16.421" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                  <path
                    d="m4.433 6h11.467a1.437 1.437 0 0 1 1.433 1.433v8.6a1.437 1.437 0 0 1 -1.433 1.432h-11.467a1.437 1.437 0 0 1 -1.433-1.433v-8.6a1.437 1.437 0 0 1 1.433-1.432z"
                    transform="translate(-1.955 -5.25)"
                  />
                  <path d="m17.331 9-7.166 5.016-7.165-5.016" transform="translate(-1.955 -6.817)" />
                </g>
              </svg>
              <span>Wprowadź swój Kod Klienta</span>
            </label>
          </div>
          <app-validate-message [control]="f.code" />
        </div>
      </div>

      <div class="row">
        <div class="col-12 www-res-pass__con__form__not-rem">
          <a class="www-res-pass__con__form__not-rem__a" [routerLink]="['/' + routeSlug.LOGIN]">
            Przejdź do logowania
          </a>
        </div>
      </div>

      <div class="row www-res-pass__btn my-3 my-md-0">
        <div class="col-12">
          <button (click)="onResetPassword()" class="www-black-btn w-100">
            <span>Resetuj hasło</span><span> ></span>
          </button>
        </div>
      </div>
    </form>

    <div class="www-res-pass__con__rig">
      <picture>
        <source media="(max-width:402px)" srcset="assets/images/pages/login/login-banner-mb.webp" />
        <img
          class="www-res-pass__con__rig__img h-auto"
          [priority]="true"
          alt="background"
          ngSrc="assets/images/pages/login/login-banner-ds.webp"
          [fill]="true"
        />
      </picture>
    </div>
  </section>

  <app-newsletter-section />
</div>
